document.addEventListener('DOMContentLoaded', function () {
  var delegationBound = false;

  function updateWishlistState(productId, isAdded) {
    var allButtons = document.querySelectorAll(
      '.vetstor-add-to-wishlist-view-product[data-product-id="' + productId + '"]'
    );
    allButtons.forEach(function (btn) {
      if (isAdded) {
        btn.classList.add('vetstor-added');
      } else {
        btn.classList.remove('vetstor-added');
      }
    });
  }

  function syncWishlistState() {
    if (!window._swat) return;
    var buttons = document.querySelectorAll('.vetstor-add-to-wishlist-view-product');
    window._swat.fetch(function (products) {
      var wishlistProductIds = new Set(
        (products || []).map(function (p) {
          return String(p.empi || p.em);
        })
      );
      buttons.forEach(function (btn) {
        var productId = btn.getAttribute('data-product-id');
        if (productId && wishlistProductIds.has(String(productId))) {
          updateWishlistState(productId, true);
        }
      });
    });
  }

  // --- Consent helpers -------------------------------------------------------
  // Swym uses askForPermissionOnFirstClick: it does NOT load window._swat until
  // the visitor grants tracking consent (Shopify customerPrivacy). Because we
  // render a custom heart instead of Swym's native button, Swym's own first-click
  // consent popup is never injected, so a pre-consent click would otherwise dead-end
  // with no feedback. We replicate the intended flow: explicit user accept ->
  // SwymConsentManager.grantConsent() -> _swat loads -> queued action runs.

  function hasConsent() {
    try {
      if (window.SwymConsentManager && typeof window.SwymConsentManager.checkConsent === 'function') {
        return !!window.SwymConsentManager.checkConsent();
      }
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && p.preferencesProcessingAllowed && p.preferencesProcessingAllowed());
    } catch (e) {
      return false;
    }
  }

  function grantConsent() {
    if (window.SwymConsentManager && typeof window.SwymConsentManager.grantConsent === 'function') {
      return Promise.resolve(window.SwymConsentManager.grantConsent());
    }
    return Promise.resolve(false);
  }

  // Run cb once _swat is available (or give up after ~20s). Covers both the
  // SwymCallbacks queue and a polling fallback, guarded so cb runs only once.
  function whenSwatReady(cb) {
    if (window._swat) {
      cb();
      return;
    }
    var done = false;
    function run() {
      if (done) return;
      done = true;
      cb();
    }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(run);
    var n = 0;
    var t = setInterval(function () {
      if (window._swat) {
        clearInterval(t);
        run();
      } else if (++n >= 40) {
        clearInterval(t);
      }
    }, 500);
  }

  // Minimal, self-contained consent prompt (no CSS-file dependency). Only one at
  // a time. onAccept fires solely on an explicit user click — never automatically.
  function showConsentPrompt(onAccept) {
    var existing = document.getElementById('vetstor-wishlist-consent');
    if (existing) existing.parentNode.removeChild(existing);

    var wrap = document.createElement('div');
    wrap.id = 'vetstor-wishlist-consent';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-live', 'polite');
    wrap.style.cssText = [
      'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
      'z-index:99999', 'max-width:92vw', 'width:360px', 'box-sizing:border-box',
      'background:#fff', 'color:#1a1a1a', 'border:1px solid #e0e0e0',
      'border-radius:12px', 'box-shadow:0 8px 28px rgba(0,0,0,0.18)',
      'padding:16px 18px', 'font-size:14px', 'line-height:1.45',
    ].join(';');

    var msg = document.createElement('p');
    msg.style.cssText = 'margin:0 0 12px 0;';
    msg.textContent =
      'Pro ukládání oblíbených potřebujeme uložit cookies. Chcete je povolit?';

    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:8px;justify-content:flex-end;';

    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.textContent = 'Teď ne';
    dismiss.style.cssText =
      'cursor:pointer;border:1px solid #d0d0d0;background:#f5f5f5;color:#1a1a1a;border-radius:8px;padding:8px 14px;font-size:14px;';

    var accept = document.createElement('button');
    accept.type = 'button';
    accept.textContent = 'Povolit';
    accept.style.cssText =
      'cursor:pointer;border:none;background:#1a1a1a;color:#fff;border-radius:8px;padding:8px 14px;font-size:14px;';

    function close() {
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }
    dismiss.addEventListener('click', close);
    accept.addEventListener('click', function () {
      close();
      onAccept();
    });

    row.appendChild(dismiss);
    row.appendChild(accept);
    wrap.appendChild(msg);
    wrap.appendChild(row);
    document.body.appendChild(wrap);
    accept.focus();
  }

  // --- Wishlist actions ------------------------------------------------------
  // Guarantees a button is re-enabled exactly once. Swym's add/remove success
  // callback is the normal path, but the FIRST add/remove right after consent is
  // granted (when _swat has only just loaded) can silently never fire its
  // callback — which would leave that button disabled forever and swallow every
  // later click on it. The watchdog re-enables after a timeout so the heart is
  // always clickable again, even if Swym never calls us back.
  function reenableOnce(btn) {
    var settled = false;
    var t = setTimeout(function () {
      if (settled) return;
      settled = true;
      btn.disabled = false;
    }, 5000);
    return function () {
      if (settled) return;
      settled = true;
      clearTimeout(t);
      btn.disabled = false;
    };
  }

  function readButton(btn) {
    return {
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id'),
      productUrl: btn.getAttribute('data-product-url'),
      productTitle: btn.getAttribute('data-product-title'),
      productImage: btn.getAttribute('data-product-image'),
      productPrice: btn.getAttribute('data-product-price'),
    };
  }

  function addWishlist(btn, d) {
    if (!window._swat) {
      btn.disabled = false;
      return;
    }
    var done = reenableOnce(btn);
    window._swat.addToWishList(
      {
        epi: d.variantId,
        du: d.productUrl,
        empi: d.productId,
        dt: d.productTitle,
        iu: d.productImage,
        pr: d.productPrice,
      },
      function () {
        updateWishlistState(d.productId, true);
        done();
      }
    );
  }

  function toggleWishlist(btn, d) {
    btn.disabled = true;
    if (btn.classList.contains('vetstor-added')) {
      var done = reenableOnce(btn);
      window._swat.removeFromWishList(
        {
          epi: d.variantId,
          empi: d.productId,
          du: d.productUrl,
          dt: d.productTitle,
          iu: d.productImage,
          pr: d.productPrice,
        },
        function () {
          updateWishlistState(d.productId, false);
          done();
        }
      );
    } else {
      addWishlist(btn, d);
    }
  }

  function bindDelegation() {
    if (delegationBound) return;
    delegationBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.vetstor-add-to-wishlist-view-product');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      var d = readButton(btn);

      // Consented and SDK ready → normal add/remove.
      if (window._swat) {
        toggleWishlist(btn, d);
        return;
      }

      // Consented but _swat not loaded yet (timing) → queue the add once ready.
      if (hasConsent()) {
        btn.disabled = true;
        whenSwatReady(function () {
          addWishlist(btn, d);
        });
        return;
      }

      // No consent → ask explicitly. Only grant on the user's own click, then
      // wait for _swat and perform the add. This gives feedback instead of a
      // silently swallowed click.
      showConsentPrompt(function () {
        btn.disabled = true;
        grantConsent().then(function (ok) {
          if (!ok) {
            btn.disabled = false;
            return;
          }
          whenSwatReady(function () {
            addWishlist(btn, d);
            syncWishlistState();
          });
        });
      });
    });
  }

  function initSwym() {
    if (!window._swat) {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(initSwym);
      return;
    }
    bindDelegation();
    syncWishlistState();
  }

  // Re-run after grid updates (load more, facets). Call from pagination.js / facets.js if needed.
  window.vetstorWishlistReinit = function () {
    if (window._swat) syncWishlistState();
  };

  // Bind clicks immediately so the heart works pre-consent (shows the consent
  // prompt on click). delegationBound makes repeat calls a no-op.
  bindDelegation();
  initSwym();

  // Luigi search updates grid via facets:luigi-search-refresh
  document.addEventListener('facets:luigi-search-refresh', function () {
    if (typeof window.vetstorWishlistReinit === 'function') {
      window.vetstorWishlistReinit();
    }
  });

  // Fallback: Swym app may load after us and not call SwymCallbacks. Poll for _swat.
  var pollCount = 0;
  var poll = setInterval(function () {
    if (window._swat) {
      clearInterval(poll);
      bindDelegation();
      initSwym();
      return;
    }
    if (++pollCount >= 40) clearInterval(poll); // ~20s
  }, 500);
});
